//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { Check } from '../../../components/ui/check/Check';
import { Option } from '../../../components/ui/check/Option';
import { useStore } from '../../../store/store';
import { useNav } from '../../../hooks/nav';
import { ReactComponent as BackIcon } from '../../../assets/images/arrowLeft.svg';
import { ReactComponent as QuotesIcon } from '../../../assets/images/quotes.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const statementSeventh = useStore((state) => state.statementSeventh);
  const setStatementSeventh = useStore((state) => state.setStatementSeventh);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.statement.title')}</Title>
        <div className={'message'}>
          <QuotesIcon />
          <Text size='m' medium>
            🤔 {t('onboarding.statement.subTitles.statementSeventh')}
          </Text>
        </div>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={statementSeventh}
          onChange={(value) => {
            setStatementSeventh(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'statement-7',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Yes'}>{t('onboarding.statement.options.yes')}</Option>
          <Option value={'Sometimes'}>{t('onboarding.statement.options.sometimes')}</Option>
          <Option value={'No'}>{t('onboarding.statement.options.no')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
